export default __webpack_public_path__ + "static/media/screen-white.fd0e0903.svg";